import React from 'react';
import { createNativeStackNavigator } from '@react-navigation/native-stack';
import { 
  Calendar,
  AddEvent
} from '@screens';

export type CalendarStackParamList = {
  CalendarMain: undefined;
  AddEvent: undefined;
};

const Stack = createNativeStackNavigator<CalendarStackParamList>();

const CalendarStackNavigator: React.FC = () => {
  return (
    <Stack.Navigator
      screenOptions={{
        headerShown: false,
      }}
    >
      <Stack.Screen 
        name="CalendarMain" 
        component={Calendar} 
      />
      <Stack.Screen 
        name="AddEvent" 
        component={AddEvent} 
      />
    </Stack.Navigator>
  );
};

export default CalendarStackNavigator; 